module.exports = __webpack_public_path__ + "static/media/react.4db9d173.png";